import { BASE_URL } from "@/constants/config";
import { request } from "@/utils/request";

export const UNSUBSCRIBED_USERS_ENDPOINTS = {
  base: `${BASE_URL}api/unsubscribed-users/`,
  detail: (id) => `${UNSUBSCRIBED_USERS_ENDPOINTS.base}${id}/`,
  add: `${BASE_URL}api/unsubscribed-users/add-unsubscribed/`
};

class UnsubscribedUsers {
  async removeUnsubscribe(id) {
    return await request({
      url: UNSUBSCRIBED_USERS_ENDPOINTS.detail(id),
      method: "DELETE",
    });
  }
  async addUnsubscribed(payload) {
    return await request({
      url: UNSUBSCRIBED_USERS_ENDPOINTS.add,
      method: "POST",
      body: payload
    })
  }
}

export const UnsubscribedUsersService = new UnsubscribedUsers();
